import React, { useState,useEffect } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../context/AuthContext";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar"
import api from "../api/api";
import { useParams } from 'react-router-dom';
import * as Icon from 'react-feather';
import DeleteUser from "../user-management/manageUser/DeleteUser";
import { useTranslation } from "react-i18next";
const UserDetails = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  const { id: userId } = useParams();

  const [loadingDetails, setLoadingDetails] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const fetchData = async () => {
  
    setLoadingDetails(true)
    setError(null)

    try {
      let typeurl;
    
      if(user.type === "supplier")typeurl="/supplier-user-details/"
      else if(user.type === "agency")typeurl="/agency-user-details/"
      else return

      console.log("Sending request to:", typeurl, "with ID:", userId);

      const response = await api.get(typeurl, {
        params: { id: userId }
      });
  
      setData(response.data.user_details)
    } catch (error) {
      console.log( error);
      
      setError(error.response.data.error)
      console.log("Response Code:", error.response.data.error);
    } finally {
      setLoadingDetails(false);
    }
  }

  
  

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(()=>{
    fetchData()
  },[])
    
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
        {
          (loadingDetails || error) ? (
            <div style={{ textAlign: "center", margin: "10em" }}>
              {loadingDetails && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
              {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
              )}
            </div>
          ) : (
            <div className="content container-fluid">
              {/* Page Header */}
              <div className="page-header">
                <div className="content-page-header d-flex justify-content-between">
                  <h5>{t("User Details")}</h5>
                  {
                    data.role === "Staff" && (
                      <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#delete_user">{t("Delete")}</button>
                    )
                  }
                </div>
              </div>
              {/* Read-Only Form */}
              <div className="container">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="loginbox">
                      <div className="login-right">
                        <div className="login-right-wrap">
                          <>
                            <div className="row">
                              {/* Personal Info */}
                              <div className="col-md-6 mb-4">
                                <div className="separator my-4">
                                  <span>{t("USER INFO")}</span>
                                </div>
                                {/* name, email, phone */}
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Name")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.name}
                                    readOnly    
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Email")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.email}
                                    readOnly
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Role")}</label>
                                  <input
                                    className="form-control"
                                    type="tel"
                                    defaultValue={data.role}
                                    readOnly
                                  />
                                </div>
                              </div>

                              {/* Company Info */}
                              <div className="col-md-6">
                                <div className="separator my-4">
                                  <span>{t("COMPANY INFO")}</span>
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                  <div className="position-relative rounded border border-secondary d-flex justify-content-center align-items-center overflow-hidden bg-light" style={{ width: '150px', height: '150px'}}>
                                    {data.imgprofile ? (
                                      <img
                                        src={data.imgprofile}
                                        alt="Profile"
                                        className="w-100 h-100"
                                        style={{ objectFit: 'cover' }}
                                      />
                                    ) : (
                                      <></>
                                    )}
                                    {/* <div 
                                      onMouseEnter={() => setIsHovered(true)}
                                      onMouseLeave={() => setIsHovered(false)}
                                      className=
                                      {isHovered ?
                                        ("position-absolute w-100 h-100 bg-secondary opacity-50 d-flex justify-content-center align-items-center text-center")
                                        :
                                        ("position-absolute w-100 h-100 bg-secondary opacity-0 d-flex justify-content-center align-items-center text-center")
                                      } 
                                      style={{objectFit: 'cover'}} data-bs-toggle="modal" data-bs-target="#update_image">
                                      <p className="text-center"><Icon.Edit size={25} color="black"/></p>
                                    </div> */}
                                  </div>
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Company Name")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.company_name}
                                    readOnly
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Email")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.admin_email}
                                    readOnly
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Contact Number")}</label>
                                  <input
                                    className="form-control"
                                    type="tel"
                                    defaultValue={data.phone}
                                    readOnly
                                  />
                                </div>
                                {
                                  (user.type === "agency")&&
                                  <>
                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Employment Registration")}</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={data.employment_registration}
                                        readOnly
                                      />
                                    </div>
                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Registration Number")}</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={data.registration_number}
                                        readOnly
                                      />
                                    </div>
                                  </>
                                }
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Address")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.location}
                                    readOnly
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label className="form-control-label">{t("Country")}</label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    defaultValue={data.region}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Read-Only Form */}
            </div>
          )}
        </div>
      </div>

      <DeleteUser selected_user={data} />
    </>

        
  );
}

UserDetails.propTypes = {
  user: PropTypes.shape({
      company: PropTypes.string,
      name: PropTypes.string,
      email: PropTypes.string,
  }).isRequired,
};

export default UserDetails;      